import { FC } from 'react';
import { useUserRole } from '@/hooks/use-user-role';
import { OrganisationPoliciesPage } from './organisation-policies-page';
import { PlatformPoliciesPage } from './platform-policies-page';

export const PoliciesPage: FC = () => {
  const { isPlatformAdmin, isOrgAdmin } = useUserRole();

  if (isPlatformAdmin) {
    return <PlatformPoliciesPage />;
  } else if (isOrgAdmin) {
    return <OrganisationPoliciesPage />;
  } else {
    return <></>;
  }
};
